import { render } from "./PropertyDescriptionsListing.vue?vue&type=template&id=1f63b398&ts=true"
import script from "./PropertyDescriptionsListing.vue?vue&type=script&lang=ts"
export * from "./PropertyDescriptionsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__